import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Optional } from '@angular/core';
import { WINDOW } from '@noda-lib/utils/injection';
import { Observable, of, take } from 'rxjs';
import * as i1 from '@noda-lib/utils/cookies';
var EnGTMEvents = /*#__PURE__*/function (EnGTMEvents) {
  EnGTMEvents["DEFAULT_EVENT_NAME"] = "flowEvent";
  return EnGTMEvents;
}(EnGTMEvents || {});
class GTMEvent {
  constructor(candidate) {
    this.event = null;
    this.eventLabel = null;
    this.eventCategory = null;
    this.eventAction = 'appEvent';
    this.options = null;
    this.customOptions = null;
    Object.assign(this, candidate);
  }
  patchOptions(options) {
    this.options = Object.assign({}, this.options, options);
  }
  getGTMOptions() {
    const {
      options,
      customOptions,
      ...rest
    } = this;
    return {
      ...rest,
      options: typeof options === 'string' ? options : JSON.stringify(options),
      customOptions: typeof customOptions === 'string' ? customOptions : JSON.stringify(customOptions)
    };
  }
}
const GTM_CONFIG = new InjectionToken('GTM_CONFIG');
const GTM_EXTRA_EVENT_OPTIONS = new InjectionToken('GTM_EXTRA_EVENT_OPTIONS');
let GTMService = /*#__PURE__*/(() => {
  class GTMService {
    constructor(config, window, extraEventOptionsGetter, cookieService) {
      this.config = config;
      this.window = window;
      this.extraEventOptionsGetter = extraEventOptionsGetter;
      this.cookieService = cookieService;
      this.lastAnalyticsEventName = null;
      this.init();
    }
    init() {
      try {
        const isNotExistEventsDataLayer = !Boolean(this.window.dataLayer);
        if (isNotExistEventsDataLayer) {
          this.window.dataLayer = [];
        }
      } catch (error) {
        console.error('Setup GTM analytics first!', error);
      }
    }
    addEvent(candidate, isMultiple = false) {
      try {
        const {
          eventCategory,
          eventPrefix
        } = this.config;
        const eventName = candidate.event ?? EnGTMEvents.DEFAULT_EVENT_NAME;
        const partialEvent = Object.assign({
          eventCategory
        }, candidate, {
          event: `${eventPrefix}_${eventName}`
        });
        const analyticsEvent = new GTMEvent(partialEvent);
        const isCanAddEvent = this.lastAnalyticsEventName !== analyticsEvent.event || isMultiple;
        if (isCanAddEvent) {
          const {
            dataLayer
          } = this.window;
          this.lastAnalyticsEventName = analyticsEvent.event;
          Boolean(this.extraEventOptionsGetter) ? this.pushEventWithOptions(dataLayer, analyticsEvent) : dataLayer.push(analyticsEvent.getGTMOptions());
        }
      } catch (error) {
        console.error(`Add Event: `, error);
      }
    }
    getGaClientId() {
      const cookiesHasClientID = this.cookieService.has('_ga');
      return cookiesHasClientID ? this.cookieService.get('_ga').split('.').slice(2).join('.') : '';
    }
    pushEventWithOptions(dataLayer, event) {
      let extraOptions = this.extraEventOptionsGetter();
      if (!(extraOptions instanceof Observable)) {
        extraOptions = of(extraOptions);
      }
      extraOptions.pipe(take(1)).subscribe(options => {
        event.patchOptions(options);
        dataLayer.push(event.getGTMOptions());
      });
    }
    static {
      this.ɵfac = function GTMService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GTMService)(i0.ɵɵinject(GTM_CONFIG), i0.ɵɵinject(WINDOW), i0.ɵɵinject(GTM_EXTRA_EVENT_OPTIONS, 8), i0.ɵɵinject(i1.CookiesService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GTMService,
        factory: GTMService.ɵfac
      });
    }
  }
  return GTMService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideGTMAnalytics(config, ...features) {
  const providers = Array.from(features).concat([GTMService, {
    provide: GTM_CONFIG,
    useValue: config
  }]);
  return providers;
}
function withGTMExtraEventOptions(factory) {
  return {
    useFactory: factory,
    provide: GTM_EXTRA_EVENT_OPTIONS
  };
}

/**
 * Generated bundle index. Do not edit.
 */

export { GTMService, provideGTMAnalytics, withGTMExtraEventOptions };
